var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"usuarios"},[_c('v-card',{staticClass:"py-4 px-2 auth-content",attrs:{"tile":""}},[_c('v-form',[_c('PageTitle',{attrs:{"main":"Administração","icon":"mdi-pencil-box-outline","sub":"Cadastro de menus do sistema","home":"/administracao"}}),_c('menu-sys')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }